module.exports = __webpack_public_path__ + "img/send.5970c4b7.svg";